export default __webpack_public_path__ + "static/media/ai2.8d33146c.jpg";